import { getTodayDateString } from '@/lib/date'
import { StateCreator } from 'zustand'
import { initialRouteState } from './state'
import { RouteActions, RouteStore } from './types'

export const createRouteActions: StateCreator<
  RouteStore,
  [],
  [],
  RouteActions
> = (set) => ({
  setCharity: (charity) => set({ charity, error: null }),
  setDonations: (donations) => set({ donations }),
  setSelectedVehicleId: (vehicleId) => set({ selectedVehicleId: vehicleId }),
  setSelectedDate: (date) =>
    set({ selectedDate: date, dateSelectedOn: getTodayDateString() }),
  clearRoute: () =>
    set({
      ...initialRouteState,
      selectedDate: getTodayDateString(),
    }),
})
